module.exports = __webpack_public_path__ + "static/media/18ECA39.7aec699a.jpg";